/* Colección — Dirección A · Editorial (mockup: coleccion.jsx).
   Lee ?c= o ?marca= (URLs existentes, no se renombran), filtra/ordena
   window.CATALOG en vivo. Bottom-sheet de filtros (sidebar en desktop) con
   counts facetados, chips azules con ✕, paginación editorial CARGAR MÁS y
   estado vacío con fake-door a WhatsApp. Lógica pura expuesta en COL._pure. */
(function(){
  var params = new URLSearchParams(location.search);
  var marca = params.get("marca");
  var tipo = params.get("tipo");          // deep-link de chip de tipo desde el menú (?c=&tipo=)
  var soloSale = params.get("sale") === "1"; // deep-link "Sale" del menú
  var c = params.get("c") || ((marca || soloSale) ? "todas" : "tenis");
  /* colección NATIVA de Shopify (/collections/<handle>): si window.COLLECTION trae un handle real
     (no 'all'), mostramos los productos de ESA colección. La nav por ?c= sigue intacta. */
  var COLL_INFO = window.COLLECTION || null;
  var nativeHandle = (COLL_INFO && COLL_INFO.handle && COLL_INFO.handle !== "all" && COLL_INFO.handle !== "frontpage") ? COLL_INFO.handle : null;
  var collSet = null; // Set de handles de la colección nativa (se llena por fetch antes del primer render)
  var TITLES = { tenis:"TENIS", ropa:"ROPA", accesorios:"ACCESORIOS", novedades:"NOVEDADES", todas:"TODO" };
  var CATS = [["tenis","Tenis"],["ropa","Ropa"],["accesorios","Accesorios"]];
  /* los 3 rangos del mockup: particionan todo el catálogo real */
  var PRECIOS = [
    { label:"Hasta $2,000", min:null, max:2000 },
    { label:"$2,000–$5,000", min:2000, max:5000 },
    { label:"$5,000+", min:5000, max:null }
  ];
  var ORDENES = [["default","NOVEDADES"],["precio-asc","PRECIO ↑"],["precio-desc","PRECIO ↓"]];
  var TOP_MARCAS = 5;
  var TOP_TIPOS = 6;
  /* tipos genéricos/sucios del dato de Shopify se agrupan como "Otro" (no inventar taxonomía) */
  var TIPO_GENERICO = { "Ropa":1, "Calzado":1, "Otro":1 };
  function tipoDe(p){ return (p.type && !TIPO_GENERICO[p.type]) ? p.type : "Otro"; }
  var state = { sizes:[], brands: marca ? [marca] : [], cats:[], types: tipo ? [tipo] : [], precio:null,
    soloDisponible:false, orden:"default", shown:0, marcasAbiertas:false, tiposAbiertos:false };

  /* ---------- lógica pura (testeable vía COL._pure) ---------- */
  function base(ps){
    var b;
    if (collSet) b = ps.filter(function(p){ return collSet.has(p.handle); }); // colección nativa
    else if (c === "novedades") b = ps.slice(0, 24); // el pull viene recientes-primero
    else if (c === "todas") b = ps;
    else b = ps.filter(function(p){ return p.category === c; });
    if (soloSale) b = b.filter(function(p){ return p.variants.some(function(v){ return v.compareAt && v.compareAt > v.price; }); });
    return b;
  }
  /* handles de una colección nativa de Shopify (público, paginado de 250) */
  function fetchCollHandles(handle){
    var set = new Set();
    function pg(page){
      return fetch("/collections/" + handle + "/products.json?limit=250&page=" + page, { headers: { "Accept": "application/json" } })
        .then(function(r){ return r.ok ? r.json() : { products: [] }; })
        .then(function(d){
          var ps = (d && d.products) || [];
          ps.forEach(function(p){ set.add(p.handle); });
          return ps.length < 250 ? set : pg(page + 1);
        }).catch(function(){ return set; });
    }
    return pg(1);
  }
  function minPrice(p){
    var avail = p.variants.filter(function(v){ return v.available; });
    if (avail.length) return Math.min.apply(null, avail.map(function(v){ return v.price; }));
    return (p.variants[0]||{price:0}).price;
  }
  function enRango(n, r){
    if (!r) return true;
    if (r.max !== null && n > r.max) return false;
    if (r.min !== null && n <= r.min) return false;
    return true;
  }
  /* tallas de tenis por RANGO de CM (cambio Kike 12/07): la opción "24–25 CM"
     matchea cualquier talla cuyo CM caiga en [24, 25] inclusive (24, 24.1, 25…).
     Las tallas sin CM (letras, solo-EU) siguen matcheando por etiqueta exacta. */
  function cmDe(size){
    var m = String(size).match(/([\d.]+)\s*CM/i);
    return m ? parseFloat(m[1]) : null;
  }
  function rangoDe(sel){
    var r = String(sel).match(/^([\d.]+)–([\d.]+) CM$/);
    return r ? { lo: parseFloat(r[1]), hi: parseFloat(r[2]) } : null;
  }
  function sizeMatch(sel, size){
    var r = rangoDe(sel);
    if (r){
      var cm = cmDe(size);
      return cm !== null && cm >= r.lo && cm <= r.hi;
    }
    return UI.sizeLabel(size) === sel;
  }
  /* matches con skip de un grupo: para counts facetados (el count de una opción
     respeta los demás filtros activos, pero no los de su propio grupo) */
  function matches(p, st, skip){
    if (skip !== "brands" && st.brands.length && st.brands.indexOf(p.brand) < 0) return false;
    if (skip !== "cats" && st.cats.length && st.cats.indexOf(p.category) < 0) return false;
    if (skip !== "types" && st.types.length && st.types.indexOf(tipoDe(p)) < 0) return false;
    if (skip !== "sizes" && st.sizes.length &&
        !p.variants.some(function(v){ return v.available && st.sizes.some(function(s){ return sizeMatch(s, v.size); }); })) return false;
    if (skip !== "precio" && !enRango(minPrice(p), st.precio === null ? null : PRECIOS[st.precio])) return false;
    if (skip !== "solo" && st.soloDisponible && !p.variants.some(function(v){ return v.available; })) return false;
    return true;
  }
  function filtrados(){
    var ps = base(window.CATALOG.products).filter(function(p){ return matches(p, state, null); });
    if (state.orden === "precio-asc") ps.sort(function(a,b){ return minPrice(a)-minPrice(b); });
    if (state.orden === "precio-desc") ps.sort(function(a,b){ return minPrice(b)-minPrice(a); });
    return ps; // default = orden del catálogo (created_at desc) = NOVEDADES
  }
  var SIZE_ORDER = {XS:1,S:2,M:3,L:4,XL:5,XXL:6,Unitalla:99};
  function sizeSort(a,b){
    var na = parseFloat(a), nb = parseFloat(b);
    if (!isNaN(na) && !isNaN(nb)) return na - nb;
    if (!isNaN(na)) return -1;
    if (!isNaN(nb)) return 1;
    var o = (SIZE_ORDER[a]||50) - (SIZE_ORDER[b]||50);
    if (o) return o;
    return String(a).localeCompare(String(b));
  }
  /* tallas del base, facetadas: las tallas con CM se agrupan en rangos de 1 cm
     ("24–25 CM", listadas por floor: 24.0 vive en 24–25); letras y solo-EU
     conservan su etiqueta individual (UI.sizeLabel) */
  function tallasDe(){
    var s = {};
    base(window.CATALOG.products).forEach(function(p){
      if (!matches(p, state, "sizes")) return;
      p.variants.forEach(function(v){
        if (!v.available) return;
        var cm = cmDe(v.size);
        if (cm !== null) s[Math.floor(cm) + "–" + (Math.floor(cm) + 1) + " CM"] = 1;
        else s[UI.sizeLabel(v.size)] = 1;
      });
    });
    state.sizes.forEach(function(x){ s[x] = 1; }); // las seleccionadas no desaparecen
    return Object.keys(s).sort(sizeSort);
  }
  /* marcas del base con count facetado, orden: profundidad desc, luego alfabético */
  function marcasDe(){
    var m = {};
    base(window.CATALOG.products).forEach(function(p){
      if (m[p.brand] === undefined) m[p.brand] = 0;
      if (matches(p, state, "brands")) m[p.brand]++;
    });
    state.brands.forEach(function(b){ if (m[b] === undefined) m[b] = 0; }); // siempre destildables
    var arr = Object.keys(m).map(function(b){ return { name:b, count:m[b] }; });
    arr.sort(function(a,b){ return b.count - a.count || a.name.localeCompare(b.name, "es"); });
    return arr.filter(function(x){ return x.count > 0 || state.brands.indexOf(x.name) >= 0; });
  }
  /* tipos del base con count facetado (High Top, Hoodie, Gorra...), "Otro" al final */
  function tiposDe(){
    var m = {};
    base(window.CATALOG.products).forEach(function(p){
      var t = tipoDe(p);
      if (m[t] === undefined) m[t] = 0;
      if (matches(p, state, "types")) m[t]++;
    });
    state.types.forEach(function(t){ if (m[t] === undefined) m[t] = 0; }); // siempre destildables
    var arr = Object.keys(m).map(function(t){ return { name:t, count:m[t] }; });
    arr.sort(function(a,b){
      if (a.name === "Otro") return 1;
      if (b.name === "Otro") return -1;
      return b.count - a.count || a.name.localeCompare(b.name, "es");
    });
    return arr.filter(function(x){ return x.count > 0 || state.types.indexOf(x.name) >= 0; });
  }
  function catsCount(){
    var m = { tenis:0, ropa:0, accesorios:0 };
    base(window.CATALOG.products).forEach(function(p){
      if (matches(p, state, "cats") && m[p.category] !== undefined) m[p.category]++;
    });
    return m;
  }
  function nFiltros(){
    return state.sizes.length + state.brands.length + state.cats.length + state.types.length +
      (state.precio !== null ? 1 : 0) + (state.soloDisponible ? 1 : 0);
  }

  /* ---------- render ---------- */
  function esc(s){ return String(s).replace(/'/g, "\\'"); }
  function lote(){ return (window.matchMedia && matchMedia("(min-width:900px)").matches) ? 16 : 8; }
  function etiquetaOrden(){
    for (var i = 0; i < ORDENES.length; i++) if (ORDENES[i][0] === state.orden) return ORDENES[i][1];
    return ORDENES[0][1];
  }

  function render(){
    var ps = filtrados(), total = ps.length;
    if (!state.shown) state.shown = lote();
    var vis = ps.slice(0, state.shown);
    var grid = document.getElementById("grid");
    grid.innerHTML = vis.map(UI.card.bind(UI)).join("");
    grid.style.display = total ? "" : "none";
    document.getElementById("vacio").hidden = total !== 0;
    document.getElementById("pager").innerHTML = !total ? "" :
      '<span class="col-pager-n">MOSTRANDO ' + vis.length + ' DE ' + total + '</span>' +
      (vis.length < total ? '<button class="col-more" data-track="cargar-mas" onclick="COL.mas()">CARGAR MÁS</button>' : '');

    var titulo = nativeHandle ? String((COLL_INFO && COLL_INFO.title) || nativeHandle).toUpperCase()
      : soloSale ? "SALE"
      : (marca && state.brands.indexOf(marca) >= 0) ? marca.toUpperCase()
      : (TITLES[c] || c.toUpperCase());
    document.getElementById("colTitle").textContent = titulo;
    document.getElementById("colSub").textContent =
      total === 0 ? "0 modelos con estos filtros." :
      total === 1 ? "1 modelo · verificado, ya en México." :
      total + " modelos · todos verificados, todos en México.";
    document.title = titulo + " — COMMONS®";

    var n = nFiltros();
    document.getElementById("btnFiltrar").textContent = "FILTRAR" + (n ? " (" + n + ")" : "");
    document.getElementById("ordenVal").textContent = etiquetaOrden();
    /* contador en la barra (visible solo en desktop, donde FILTRAR se esconde) */
    var bn = document.getElementById("colBarN");
    if (bn) bn.textContent = total === 1 ? "1 PIEZA" : total + " PIEZAS";
    renderChips();
  }

  function renderChips(){
    var h = "";
    var chip = function(label, fn){
      return '<button class="chip" data-track="filtro-chip" onclick="' + fn + '">' +
        label + ' <span class="chip-x">✕</span></button>';
    };
    state.brands.forEach(function(b){ h += chip(b.toUpperCase(), "COL.toggleBrand('" + esc(b) + "')"); });
    state.types.forEach(function(t){ h += chip(t.toUpperCase(), "COL.toggleType('" + esc(t) + "')"); });
    state.sizes.forEach(function(s){ h += chip(s, "COL.toggleSize('" + esc(s) + "')"); });
    state.cats.forEach(function(x){ h += chip(TITLES[x] || x.toUpperCase(), "COL.toggleCat('" + esc(x) + "')"); });
    if (state.precio !== null) h += chip(PRECIOS[state.precio].label, "COL.setPrecio(" + state.precio + ")");
    if (state.soloDisponible) h += chip("SOLO DISPONIBLES", "COL.toggleDisp()");
    if (h) h += '<button class="chip chip-clear" data-track="filtro-chip" onclick="COL.limpiar()">Limpiar todo</button>';
    document.getElementById("chips").innerHTML = h;
  }

  function isSheetOpen(){ return document.getElementById("sheet").classList.contains("open"); }

  function renderSheet(){
    var sheet = document.getElementById("sheet");
    var st = sheet.scrollTop;

    var fRow = function(on, fn, nombre, count, clase){
      return '<button class="f-row' + (clase ? ' ' + clase : '') + '" aria-pressed="' + on + '" onclick="' + fn + '">' +
        '<span class="f-box' + (on ? ' on' : '') + '">✓</span>' +
        '<span class="f-name">' + nombre + '</span>' +
        (count !== null ? '<span class="f-count">' + count + '</span>' : '') + '</button>';
    };

    /* tipo — el sub-tipo real de la categoría (High Top, Hoodie, Gorra...);
       top-6 + seleccionados, expandible. Con un solo tipo sería tautológico: se omite. */
    var tipos = tiposDe();
    var listaT = tipos, hVerT = "";
    if (!state.tiposAbiertos && tipos.length > TOP_TIPOS){
      listaT = tipos.slice(0, TOP_TIPOS);
      tipos.slice(TOP_TIPOS).forEach(function(t){
        if (state.types.indexOf(t.name) >= 0) listaT.push(t);
      });
      hVerT = '<button class="f-ver" onclick="COL.verTipos()">VER LOS ' + tipos.length + ' TIPOS</button>';
    }
    var hTipos = tipos.length < 2 ? "" :
      '<p class="sheet-label">TIPO</p><div class="f-list">' + listaT.map(function(t){
        return fRow(state.types.indexOf(t.name) >= 0, "COL.toggleType('" + esc(t.name) + "')", t.name, t.count);
      }).join("") + hVerT + '</div>';

    /* talla — chips compartidos con la PDP. Las tallas SIN parte CM (ej. McQueen
       "44 EU") van en su propio subgrupo con divisor: mezclarlas con la escala CM
       confunde (44 EU no es talla mayor que 29.7 CM) y convertir sería inventar. */
    var tallas = tallasDe();
    var soloEU = tallas.filter(function(t){ return /EU$/i.test(t) && !/CM/i.test(t); });
    var tallasStd = tallas.filter(function(t){ return soloEU.indexOf(t) < 0; });
    var chipT = function(t){
      return '<button class="talla' + (state.sizes.indexOf(t) >= 0 ? ' on' : '') +
        '" onclick="COL.toggleSize(\'' + esc(t) + '\')">' + t + '</button>';
    };
    var larga = tallas.some(function(t){ return t.length > 6; });
    var hTallas = '<div class="tallas' + (larga ? ' tallas--larga' : '') + '">' +
      tallasStd.map(chipT).join("") +
      (soloEU.length ? '<span class="tallas-div">SOLO EU</span>' + soloEU.map(chipT).join("") : '') +
      '</div>';

    /* marca — checkboxes con count real; top-5 + seleccionadas, expandible */
    var marcas = marcasDe();
    var lista = marcas, hVer = "";
    if (!state.marcasAbiertas && marcas.length > TOP_MARCAS){
      lista = marcas.slice(0, TOP_MARCAS);
      marcas.slice(TOP_MARCAS).forEach(function(m){
        if (state.brands.indexOf(m.name) >= 0) lista.push(m);
      });
      hVer = '<button class="f-ver" onclick="COL.verMarcas()">VER LAS ' + marcas.length + ' MARCAS</button>';
    }
    var hMarcas = '<div class="f-list">' + lista.map(function(m){
      var on = state.brands.indexOf(m.name) >= 0;
      return fRow(on, "COL.toggleBrand('" + esc(m.name) + "')", m.name, m.count);
    }).join("") + hVer + '</div>';

    /* categoría — solo cuando la colección no la fija ya (novedades / todo / marca) */
    var hCats = "";
    if (c === "novedades" || c === "todas"){
      var cc = catsCount();
      var rows = CATS.filter(function(k){ return cc[k[0]] > 0 || state.cats.indexOf(k[0]) >= 0; })
        .map(function(k){
          return fRow(state.cats.indexOf(k[0]) >= 0, "COL.toggleCat('" + k[0] + "')", k[1], cc[k[0]]);
        }).join("");
      if (rows) hCats = '<p class="sheet-label">CATEGORÍA</p><div class="f-list">' + rows + '</div>';
    }

    /* precio — los 3 rangos del mockup */
    var hPrecio = '<div class="f-precios">' + PRECIOS.map(function(r, i){
      return '<button class="talla' + (state.precio === i ? ' on' : '') +
        '" onclick="COL.setPrecio(' + i + ')">' + r.label + '</button>';
    }).join("") + '</div>';

    var n = filtrados().length;
    sheet.innerHTML =
      '<div class="sheet-head"><span>FILTRAR</span><button aria-label="Cerrar" onclick="COL.closeSheet()">✕</button></div>' +
      hTipos +
      '<p class="sheet-label">TALLA</p>' + hTallas +
      '<p class="sheet-label">MARCA</p>' + hMarcas +
      hCats +
      '<p class="sheet-label">PRECIO</p>' + hPrecio +
      fRow(state.soloDisponible, "COL.toggleDisp()", "Solo disponibles", null, "f-solo") +
      '<div class="sheet-acciones">' +
        '<button class="sheet-limpiar" onclick="COL.limpiar()">LIMPIAR</button>' +
        '<button class="sheet-aplicar" data-track="filtros-aplicar" onclick="COL.closeSheet()">VER ' + n + (n === 1 ? ' PIEZA' : ' PIEZAS') + '</button>' +
      '</div>';
    sheet.scrollTop = st;
  }

  function openSheet(){
    renderSheet();
    document.getElementById("sheet").classList.add("open");
    document.getElementById("sheetVeil").classList.add("open");
    document.getElementById("btnFiltrar").setAttribute("aria-expanded", "true");
  }
  /* desktop: el sheet es sidebar persistente y se re-renderiza con cada filtro.
     En móvil solo se renderiza abierto (como siempre) — ni un pixel cambia. */
  var DESKTOP = window.matchMedia ? matchMedia("(min-width:900px)") : { matches:false };
  function refresh(){ render(); if (isSheetOpen() || DESKTOP.matches) renderSheet(); }
  function tocaFiltro(){ state.shown = lote(); refresh(); }

  window.COL = {
    toggleSize: function(s){ var i = state.sizes.indexOf(s); i < 0 ? state.sizes.push(s) : state.sizes.splice(i,1); tocaFiltro(); },
    toggleBrand: function(b){ var i = state.brands.indexOf(b); i < 0 ? state.brands.push(b) : state.brands.splice(i,1); tocaFiltro(); },
    toggleCat: function(x){ var i = state.cats.indexOf(x); i < 0 ? state.cats.push(x) : state.cats.splice(i,1); tocaFiltro(); },
    toggleType: function(t){ var i = state.types.indexOf(t); i < 0 ? state.types.push(t) : state.types.splice(i,1); tocaFiltro(); },
    verTipos: function(){ state.tiposAbiertos = true; if (isSheetOpen() || DESKTOP.matches) renderSheet(); },
    setPrecio: function(i){ state.precio = (state.precio === i) ? null : i; tocaFiltro(); },
    toggleDisp: function(){ state.soloDisponible = !state.soloDisponible; tocaFiltro(); },
    limpiar: function(){ state.sizes = []; state.brands = []; state.cats = []; state.types = []; state.precio = null; state.soloDisponible = false; tocaFiltro(); },
    verMarcas: function(){ state.marcasAbiertas = true; if (isSheetOpen() || DESKTOP.matches) renderSheet(); },
    mas: function(){ state.shown += lote(); render(); },
    /* ORDENAR = dropdown chico con las 3 opciones (review Kike 12/06; antes ciclaba) */
    toggleOrdenMenu: function(){
      var menu = document.getElementById("ordenMenu");
      if (!menu.hidden) return window.COL.closeOrdenMenu();
      menu.innerHTML = ORDENES.map(function(o){
        return '<button class="orden-op' + (state.orden === o[0] ? ' on' : '') +
          '" data-track="ordenar-op" onclick="COL.setOrden(\'' + o[0] + '\')">' + o[1] + '</button>';
      }).join("");
      menu.hidden = false;
      document.getElementById("btnOrden").setAttribute("aria-expanded", "true");
    },
    setOrden: function(k){ state.orden = k; window.COL.closeOrdenMenu(); render(); },
    closeOrdenMenu: function(){
      var menu = document.getElementById("ordenMenu");
      if (!menu || menu.hidden) return;
      menu.hidden = true;
      document.getElementById("btnOrden").setAttribute("aria-expanded", "false");
    },
    closeSheet: function(){
      document.getElementById("sheet").classList.remove("open");
      document.getElementById("sheetVeil").classList.remove("open");
      document.getElementById("btnFiltrar").setAttribute("aria-expanded", "false");
    }
  };
  /* hooks de test (node): lógica pura + estado inyectable */
  window.COL._pure = { base:base, matches:matches, filtrados:filtrados, minPrice:minPrice,
    enRango:enRango, tallasDe:tallasDe, marcasDe:marcasDe, catsCount:catsCount, tiposDe:tiposDe,
    tipoDe:tipoDe, nFiltros:nFiltros, sizeSort:sizeSort, state:state, PRECIOS:PRECIOS,
    setC:function(x){ c = x; } };

  document.addEventListener("DOMContentLoaded", function(){
    document.getElementById("btnFiltrar").addEventListener("click", openSheet);
    document.getElementById("sheetVeil").addEventListener("click", window.COL.closeSheet);
    document.getElementById("btnOrden").addEventListener("click", window.COL.toggleOrdenMenu);
    document.addEventListener("click", function(e){
      var menu = document.getElementById("ordenMenu");
      if (menu && !menu.hidden && !menu.contains(e.target) && !e.target.closest("#btnOrden"))
        window.COL.closeOrdenMenu();
    });
    document.querySelectorAll(".col-nav a[data-nav]").forEach(function(a){
      if (a.getAttribute("data-nav") === c) a.classList.add("on");
    });
    window.onCatalog(function(){
    function startRender(){
    render();
    /* scroll restoration (C-G5): al volver de una PDP por back/forward, regresa a la
       misma posición del grid y al mismo nº de items cargados. Solo en navegación
       back_forward → una visita fresca a la misma URL siempre arranca arriba. */
    var SKEY = "colpos:" + location.pathname + location.search;
    window.addEventListener("pagehide", function(){
      try { sessionStorage.setItem(SKEY, JSON.stringify({ y: window.scrollY, shown: state.shown })); } catch(e){}
    });
    try {
      var nav = (performance.getEntriesByType && performance.getEntriesByType("navigation")[0]) || null;
      var saved = JSON.parse(sessionStorage.getItem(SKEY) || "null");
      if (saved && nav && nav.type === "back_forward") {
        state.shown = Math.max(saved.shown || lote(), lote());
        render();
        requestAnimationFrame(function(){ window.scrollTo(0, saved.y || 0); });
      }
    } catch(e){}
    if (DESKTOP.matches) renderSheet(); // sidebar desktop lista desde el load
    /* si el viewport cruza a desktop (rotación/resize), la sidebar se llena */
    if (DESKTOP.addEventListener) DESKTOP.addEventListener("change", function(e){ if (e.matches) renderSheet(); });
    }
    if (nativeHandle) fetchCollHandles(nativeHandle).then(function(s){ collSet = s; startRender(); });
    else startRender();
    });
  });
  document.addEventListener("keydown", function(e){
    if (e.key === "Escape" && isSheetOpen()) window.COL.closeSheet();
    if (e.key === "Escape") window.COL.closeOrdenMenu();
  });
})();
